var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Fees Paid"}},[_c('input-radio-boolean',{attrs:{"name":"fees_paid_gross","true":"Gross","false":"Net","read_only":_vm.read_only},model:{value:(_vm.fees_paid_gross),callback:function ($$v) {_vm.fees_paid_gross=$$v},expression:"fees_paid_gross"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }